module.exports = __webpack_public_path__ + "public/Icons/dashboard.svg?e2dc4532";